import type { AttachmentInfo, CalEvent } from "../types";
import { useLoadedOnce } from "./useLoadedOnce";

/** Attachments read this session, per event and change key, so an edited invite is read again. */
const cache = new Map<string, readonly AttachmentInfo[] | null>();

/** The attachments of the meetings that have any, by event id, for the schedule rows; left out until read. */
export function useEventAttachments(
  load: (eventId: string) => Promise<readonly AttachmentInfo[]>,
  events: readonly CalEvent[],
): ReadonlyMap<string, readonly AttachmentInfo[]> {
  const items = events.filter((e) => e.hasAttachments).map((e) => ({ key: `${e.id}|${e.changeKey}`, id: e.id, load: () => load(e.id) }));
  return useLoadedOnce(cache, items, "load-row-attachments");
}
